// extracted by mini-css-extract-plugin
export default {"search-bar-wrapper":"XQJqqptvOAtsmvVy6rkH","search-bar":"NHW2KByzhafxwn554dC9","icon-wrap":"W798zavTF30clRP68WTj","search-input":"HFKV2buutIRcED4libKn"};